module.exports = __webpack_public_path__ + "static/media/kit-ar-studio.9ff4bf09.png";